window.categoryAccordionToggle = function (button){

    let self = this;
    let categoryWrapper = button.closest('.js-category-accordion');
    let nodes = categoryWrapper.querySelectorAll('.category-card');

    button.classList.toggle('category-button-show-less');

    nodes.forEach(node => {
        node.classList.toggle('category-card--visible');
    });

    button.querySelector('span').innerHTML = button.classList.contains('category-button-show-less') ? 'Méně kategorií' : 'Více kategorií';
}
